import React from 'react';
import { useTranslation } from 'react-i18next';
import './allDayToggle.css';

/**
 * Polished All day control for event create/edit forms.
 * Renders a switch row; parent owns the boolean state.
 */
export default function AllDayToggle({
  checked = false,
  onChange,
  id = 'event-all-day',
}) {
  const { t } = useTranslation('planning');
  return (
    <label
      htmlFor={id}
      className={`all-day-toggle${checked ? ' is-on' : ''}`}
    >
      <span className="all-day-toggle-icon" aria-hidden="true">
        <span className="material-symbols-outlined">
          {checked ? 'wb_sunny' : 'schedule'}
        </span>
      </span>
      <span className="all-day-toggle-copy">
        <span className="all-day-toggle-title">{t('allDay')}</span>
        <span className="all-day-toggle-hint">
          {checked ? t('allDayHintOn') : t('allDayHintOff')}
        </span>
      </span>
      <span className="all-day-toggle-switch" aria-hidden="true">
        <span className="all-day-toggle-knob" />
      </span>
      <input
        id={id}
        type="checkbox"
        className="all-day-toggle-input"
        checked={!!checked}
        onChange={(e) => onChange?.(e.target.checked)}
      />
    </label>
  );
}
